import BestPrestataireSection from "../../components/BestPrestataireSection"
import HeroSection from "../../components/HeroSection"

const Home = () => {
    return(
        <main>
            <HeroSection/>
            <BestPrestataireSection/>
            
        </main>
    )

}
export default Home